import { Grid, Box } from "@material-ui/core";
import { Button, Card } from "@roc/ui";
import { observer } from "mobx-react";
import { makeStyles } from '@material-ui/core/styles';
import { RealEstateTransactionCard } from "./realEstateTransactionCard";
import { Add } from "@material-ui/icons";
import { EditRealEstateTransactionDialog } from "./editRealEstateTransactionDialog";
import { useEffect } from "react";

const useStyles = makeStyles(theme => ({
  button: {
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(2),
    minWidth: '150px',
  },
  notesScroll: {
    backgroundColor: '#FAFAFA',
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    maxHeight: '800px',
    overflowY: 'auto',
    overflowX: 'hidden',
    boxShadow: '0 0 2px #DDD inset'
  },
}));

// readOnly hides Add: the edit store takes leadId from objectId, which is a contactId on the contact screen.
export const RealEstateTransactions = observer(({ leadDetailsStore, readOnly = false }) => {
  const classes = useStyles();
  const { editRealEstateTransactionStore } = leadDetailsStore;

  const handleOnClick = () => {
    editRealEstateTransactionStore.openAddRealEstateTransaction();
  }

  useEffect(() => {
  }, []);

  const action = (
    <Box p={1} mb={-10}>
      <Button
        testId="add-lead-activity"
        className={classes.button}
        variant="contained"
        size="small"
        color="primary"
        onClick={handleOnClick}
      >
        <Add /> Add Transaction
      </Button>
    </Box>
  );

  return (
    <Card
      title="Real Estate Transactions"
      cardHeaderProps={readOnly ? undefined : { action }}
      cardContentProps={{ className: classes.notesScroll }}
    >
      {leadDetailsStore.realEstateTransactions?.length > 0 ? (
        <Grid container spacing={2}>
          {leadDetailsStore.realEstateTransactions.map(realEstateTransaction => (
            <Grid item xs={12}>
              <RealEstateTransactionCard
                realEstateTransaction={realEstateTransaction}
                editRealEstateTransactionStore={editRealEstateTransactionStore}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Box textAlign="center">No records.</Box>
      )}
      <EditRealEstateTransactionDialog editRealEstateTransactionStore={editRealEstateTransactionStore} />
    </Card>
  );
});
